import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslationService } from 'src/app/services/translation/translation.service';

@Component({
  selector: 'app-public-pages',
  templateUrl: './public.component.html',
  styleUrl: './public.component.scss',

  imports: [RouterOutlet],
  providers: [],
})
export class PublicPageComponent {
  // the translation service is not used but the import is necessary
  // to make sure the service is initialized.
  t = inject(TranslationService);
}
